var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanRecommendation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_720",
    "data-name": "Group 720",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M33.75,24a9.75,9.75,0,1,0,9.75,9.75A9.75,9.75,0,0,0,33.75,24ZM36,38.063a3.182,3.182,0,0,1-4.5-4.5,2.494,2.494,0,0,1,.291-.244l-.028-.019a2.8,2.8,0,0,1,0-3.975,2.883,2.883,0,0,1,3.975,0,2.8,2.8,0,0,1,0,3.975l-.028.019a2.494,2.494,0,0,1,.291.244,3.169,3.169,0,0,1,0,4.5Z",
    transform: "translate(-21.75 -21.75)",
    fill: "#e86262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M116.241,90.242a1.313,1.313,0,1,0-1.856,0A1.341,1.341,0,0,0,116.241,90.242Z",
    transform: "translate(-103.312 -79.751)",
    fill: "#e86262"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M111.738,132a1.688,1.688,0,0,0-1.191,2.878,1.725,1.725,0,0,0,2.381,0A1.688,1.688,0,0,0,111.738,132Z",
    transform: "translate(-99.738 -119.625)",
    fill: "#e86262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanRecommendation);
export default __webpack_public_path__ + "static/media/PLAN_RECOMMENDATION.e2735954c35cececb4449f57e1752ac5.svg";
export { ForwardRef as ReactComponent };